import api from './Api';
import { clearSession } from '../auth/session';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  role: string;
  username: string;
  userId: number;
  firstLogin?: boolean;
}

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  fullName: string;
  phone?: string;
}

export interface RegisterResponse {
  id: number;
  username: string;
  email: string;
  message: string;
}

export const AuthApi = {
  // Login
  login: (credentials: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', credentials),

  // Register new user
  register: (data: RegisterRequest) =>
    api.post<RegisterResponse>('/auth/register', data),

  // Logout (client-side token removal)
  logout: () => {
    clearSession();
    sessionStorage.removeItem('inactiveAccount');
  },
};
